import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
var Trade = function Trade() {
  return import('@/components/templates/Trade');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
import Nl2br from 'vue-nl2br';
import Head from '~/assets/scripts/Head';
export default {
  components: {
    Trade: Trade,
    PageTitle: PageTitle,
    Nl2br: Nl2br
  },
  data: function data() {
    return {
      imageUrl: null
    };
  },
  computed: {
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getHeroType: function getHeroType() {
      return useHeroMaster().getHeroType;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    type: function type() {
      return this.$route.params.tradeType;
    },
    id: function id() {
      return Number(this.$route.params.tradeId);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var HeroTrade, Herofilename, ExtensionTrade, extensionType, accessoryTrade, memoriaTrade, heroType, memoriaFilename, heroExpTrade, landSectorTrade;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = _this.type;
            _context.next = _context.t0 === 'hero' ? 3 : _context.t0 === 'extension' ? 11 : _context.t0 === 'accessory' ? 19 : _context.t0 === 'memoria' ? 24 : _context.t0 === 'heroExpItem' ? 29 : _context.t0 === 'landSector' ? 34 : 39;
            break;
          case 3:
            _context.next = 5;
            return _this.$tradesService.getHeroTradeByTradeId(_this.id);
          case 5:
            HeroTrade = _context.sent;
            _context.next = 8;
            return _this.fetchHero(HeroTrade.heroId);
          case 8:
            Herofilename = _this.getHero(HeroTrade.heroId).filename;
            _this.imageUrl = "".concat(_this.$env.cdnUrl, "/rsc/unit/").concat(Herofilename, "/unit_ills_full_").concat(Herofilename, ".png");
            return _context.abrupt("break", 40);
          case 11:
            _context.next = 13;
            return _this.$tradesService.getExtensionTradeByTradeId(_this.id);
          case 13:
            ExtensionTrade = _context.sent;
            _context.next = 16;
            return useExtensionStore().fetchExtension(ExtensionTrade.extensionId);
          case 16:
            extensionType = _this.getExtension(ExtensionTrade.extensionId).extensionType;
            _this.imageUrl = "".concat(_this.$env.cdnUrl, "/rsc/sphere/2000/").concat(extensionType, ".png");
            return _context.abrupt("break", 40);
          case 19:
            _context.next = 21;
            return _this.$tradesService.getAccessoryTradeByTradeId(_this.id);
          case 21:
            accessoryTrade = _context.sent;
            _this.imageUrl = "".concat(_this.$env.cdnUrl, "/rsc/accessory/").concat(accessoryTrade.accessoryImageId, ".png");
            return _context.abrupt("break", 40);
          case 24:
            _context.next = 26;
            return _this.$tradesService.getMemoriaTradeByTradeId(_this.id);
          case 26:
            memoriaTrade = _context.sent;
            if (memoriaTrade.memoriaPart == 1) {
              heroType = _this.getHeroType(memoriaTrade.heroType);
              memoriaFilename = heroType.filename;
              _this.imageUrl = "".concat(_this.$env.cdnUrl, "/rsc/unit/").concat(memoriaFilename, "/unit_ills_full_").concat(memoriaFilename, ".png");
            } else if (memoriaTrade.memoriaPart == 2) {
              _this.imageUrl = "".concat(_this.$env.cdnUrl, "/static/memoria/st_mem320.png");
            } else {
              _this.imageUrl = "".concat(_this.$env.cdnUrl, "/static/memoria/BB_mem320.png");
            }
            return _context.abrupt("break", 40);
          case 29:
            _context.next = 31;
            return _this.$tradesService.getHeroExpItemTradeByTradeId(_this.id, _this.heroExpItemQuantity);
          case 31:
            heroExpTrade = _context.sent;
            _this.imageUrl = "".concat(_this.$env.cdnUrl, "/rsc/landitem/").concat(heroExpTrade.filename, ".png");
            return _context.abrupt("break", 40);
          case 34:
            _context.next = 36;
            return _this.$tradesService.getLandSectorTradeByTradeId(_this.id);
          case 36:
            landSectorTrade = _context.sent;
            _this.imageUrl = "".concat(_this.$env.staticUrl, "/land/landicon/land_icon_").concat(landSectorTrade.landType, ".png");
            return _context.abrupt("break", 40);
          case 39:
            throw new Error('Undefined trade type.');
          case 40:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchHero: function fetchHero(id) {
      return useHeroStore().fetchHero(id);
    }
  },
  head: function head() {
    var head = new Head({
      title: this.$t('common.meta.title'),
      description: this.$t('common.meta.description'),
      url: this.$env.siteUrl + this.localePath({
        name: 'trades-tradeType-tradeId',
        params: {
          tradeType: this.type,
          tradeId: this.id
        }
      }).substring(1),
      imageUrl: this.imageUrl,
      ogType: 'website',
      twitterCardType: 'summary_large_image'
    });
    return head.get();
  }
};